var headroom = '';

// Load background images
jQuery(".load-bg-img").each(function(i, obj) {
  loadBgImage(jQuery(this));
});

function loadBgImage(element) { 
  var large_img = element.attr("data-bg-large");
  var small_img = element.attr("data-bg-small");

  var bgImg = new Image();
  bgImg.onload = function() {
    element.css("background-image", "url(" + bgImg.src + ")");
    element.addClass("loaded");
  };

  if (jQuery(document).width() > 800) {
    bgImg.src = element.attr("data-bg");
  } else if (jQuery(document).width() > 400) {
    bgImg.src = element.attr("data-bg-small");
  } else {
    bgImg.src = element.attr("data-bg-tiny");
  }
}

// Navigation
jQuery(".dropdown").on("show.bs.dropdown", function() {
  var elem = jQuery(this).find(".dropdown-menu");
  setTimeout(function() {
    elem.addClass("inplace");
  }, 100);
});
jQuery(".dropdown").on("hide.bs.dropdown", function() {
  jQuery(this)
    .find(".dropdown-menu")
    .removeClass("inplace");
});
// Back button for the main menu
jQuery("#menu-primary-navigation .dropdown").on("hide.bs.dropdown", function() {
  jQuery(".subnavbar-toggler").removeClass("show");
  setTimeout(function() {
    jQuery(".subnavbar-toggler").removeClass("inplace");
  }, 200);
});
jQuery("#menu-primary-navigation .dropdown").on("show.bs.dropdown", function() {
  jQuery(".subnavbar-toggler").addClass("inplace");
  setTimeout(function() {
    jQuery(".subnavbar-toggler").addClass("show");
  }, 200);
});
jQuery(document).ready(function() {
  jQuery(document).on("click", ".dropdown-menu", function(e) {
    e.stopPropagation();
  });
});


jQuery(document).ready(function() {
  jQuery(".answer.collapse").on("hide.bs.collapse", function() {
    jQuery(this)
      .parent()
      .find("h3")
      .removeClass("showing");
  });

  jQuery(".answer.collapse").on("show.bs.collapse	", function() {
    jQuery(this)
      .parent()
      .find("h3")
      .addClass("showing");
  });

  jQuery(".nav.collapse").on("hide.bs.collapse", function() {
    jQuery(".navbar-container").removeClass("show");
    jQuery(".navbar-toggler").removeClass("show");
    jQuery("html").removeClass("show-nav");
    jQuery("body").removeClass("no-scroll");
    setTimeout(function() {
      jQuery(".navbar-container").removeClass("showing");
      jQuery(".navbar-toggler").removeClass("showing");
      jQuery("html").removeClass("showing-nav");
    }, 100);
  });

  jQuery(".nav.collapse").on("show.bs.collapse	", function() {
    jQuery(".navbar-container").addClass("showing");
    jQuery(".navbar-toggler").addClass("showing");
    jQuery("html").addClass("showing-nav");
    jQuery("body").addClass("no-scroll");

    setTimeout(function() {
      jQuery(".navbar-container").addClass("show");
      jQuery(".navbar-toggler").addClass("show");
      jQuery("html").addClass("show-nav");
    }, 100);
  });

  jQuery(".the-search-form.collapse").on("show.bs.collapse	", function() {
    setTimeout(function() {
      jQuery(".the-search-form input.search-field").focus();
    }, 300);
  });
});

// If we have a hero
if (jQuery(".page-title").length) {

  if (jQuery(".page-title").hasClass("no-img")) {

  } else {
    var bgImg = new Image();
    bgImg.onload = function() {
      jQuery(".page-title").css("background-image", "url(" + bgImg.src + ")");

      setTimeout(function() {
        jQuery(".page-title").addClass("inplace");
      }, 20);

    };

    if (jQuery(document).width() > 800) {
      bgImg.src = jQuery(".page-title").attr("data-bg");
    } else if (jQuery(document).width() > 400) {
      bgImg.src = jQuery(".page-title").attr("data-bg-small");
    } else {
      bgImg.src = jQuery(".page-title").attr("data-bg-tiny");
    }
  }
}

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function() {
        jQuery(
          ".marry-widows h1, .marry-widows h2, .marry-widows h3, .marry-widows p"
        ).each(function() {
          var string = jQuery(this).html();
          string = string.replace(/ ([^ ]*)$/, "&nbsp;$1");
          jQuery(this).html(string);
        });

        var viewport_width = jQuery(document).width();
        var offset = 0;
        //if (viewport_width < 1000) {
        //  offset = 40;
        //}

        var myElement = document.querySelector("header");
        // construct an instance of Headroom, passing the element
       headroom = new Headroom(myElement, {
          offset: offset,
          tolerance: {
            down: 11,
            up: 3
          }
        });
        // initialise
        headroom.init();

        // Secondary navigation
        /*
          var secondary_nav = document.querySelector(".secondary-nav nav");
          // construct an instance of Headroom, passing the element
          var headroom_secondary = new Headroom(secondary_nav, {
            offset: 100,
            tolerance: {
              down: 11,
              up: 3
            }
          });
          // initialise
          headroom_secondary.init();
          */
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    home: {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    about_us: {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, "_").split(/\s+/), function(
        i,
        classnm
      ) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, "finalize");
      });

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    }
  };

  // Load Events
  jQuery(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.

function getScrollTop() {
  if (typeof pageYOffset !== "undefined") {
    //most browsers except IE before #9
    return pageYOffset;
  } else {
    var B = document.body; //IE 'quirks'
    var D = document.documentElement; //IE with doctype
    D = D.clientHeight ? D : B;
    return D.scrollTop;
  }
}

function getHeaderTop(div) {
  var winTop;
  if (!div) {
    winTop = jQuery(window).scrollTop();
  } else {
    winTop = jQuery(div).offset().top;
  }
  var headerTop = winTop;
  if (headerTop > headerHidden) {
    headerTop = headerHidden;
  } else if (headerTop < 0) {
    headerTop = 0;
  }
  return headerTop;
}

// State of the header.
var top_stick = true;
var darker_nav = false;
var promo_in_place = false;

// Update the navigation based on the width of the viewport.
function updateNav() {
  //
  // Update header background color.
  //
  var from_top = jQuery(window).scrollTop();
  if (from_top > 10 && !darker_nav) {
    jQuery(".header").addClass("scrollnav");
    darker_nav = true;
  } else if (from_top <= 10 && darker_nav) {
    jQuery(".header").removeClass("scrollnav");
    darker_nav = false;
  }
}

jQuery(document).ready(function() {
  jQuery("html").addClass("js");

  //windowResizeTasks();

  updateNav();
  jQuery(window).scroll(jQuery.throttle(65, updateNav));
  jQuery(window).on("debouncedresize", function(event) {
    // Your event handler code goes here.
    updateNav();
  });
});



/* ================================
 * Map locations
 * ============================= */
jQuery(document).ready(function() {
  jQuery(document).on("facetwp-loaded", function() {
    if ("" == FWP.buildQueryString()) {
      jQuery(".reset-button").addClass("disabled");
      jQuery(".reset-button").attr("disabled", "disabled");
    } else {
      jQuery(".reset-button").removeClass("disabled");
      jQuery(".reset-button").removeAttr("disabled", "disabled");
    }

    jQuery(".facetwp-template .load-bg-img").each(function(i, obj) {
      loadBgImage(jQuery(this));
    });
  });

  jQuery(document).on("facetwp-refresh", function() {
    jQuery(".fwp-elements").addClass("loading");
  });

  jQuery(document).on("facetwp-loaded", function() {
    jQuery(".fwp-elements").removeClass("loading");
    //jQuery('.facetwp-radius-dropdown').niceSelect();
  });
});

jQuery(document).ready(function() {
  jQuery(document).on("facetwp-refresh", function() {
    jQuery(".facetwp-template").addClass("loading");
  });

  jQuery(document).on("facetwp-loaded", function() {
    jQuery(".facetwp-template").removeClass("loading");
  });
});

// Accordian stuff
jQuery(document).ready(function() {
  jQuery(".accordian.device-text").on("hidden.bs.collapse", function(e) {
    var id = e.target.id;

    // Hide others
    jQuery(".laptop-with-text .screenshot img").removeClass("show");

    console.log(id);
    jQuery("#" + id + "-dv").removeClass("show");
  });

  jQuery(".accordian.device-text").on("shown.bs.collapse", function(e) {
    var id = e.target.id;

    // Hide others
    jQuery(".laptop-with-text .screenshot img").removeClass("show");

    console.log(id);
    jQuery("#" + id + "-dv").addClass("show");
  });

  // the current open accordion will not be able to close itself
  jQuery('.accordion button[data-toggle="collapse"]').on("click", function(e) {
    if (!jQuery(this).hasClass("collapsed")) {
      e.stopPropagation();
    }
  });
});


function createCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

function eraseCookie(name) {
  createCookie(name, "", -1);
}

/* ================================
 * Cookie notice
 * ============================= */
jQuery(document).ready(function() {
  var allow_cookies = readCookie("allow_cookies");
  if (allow_cookies !== "yes") {
    jQuery(".cookie-notice").addClass("display");
    jQuery(".cookie-notice").addClass("inplace");
  } else {
    console.log("Cookies allowed.");
  }

  jQuery("#allow-cookies").click(function(event) {
    createCookie("allow_cookies", "yes", 7);

    setTimeout(function() {
      jQuery(".cookie-notice").removeClass("display");
    }, 200);
    jQuery(".cookie-notice").removeClass("inplace");

    return false;
  });
});

// Tooltips
jQuery(document).ready(function() {
  jQuery(function() {
    jQuery('[data-toggle="tooltip"]').tooltip();
  });
});


jQuery(document).ready(function() {
  jQuery(".popover-info").popover();
});


jQuery(document).ready(function() {
  // Add smooth scrolling to all links
  jQuery(".sc-content-nav.skip-to a").on("click", function(event) {
    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;
        // Using jQuery's animate() method to add smooth page scroll
        // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
        jQuery("html, body").animate(
          {
            scrollTop: jQuery(hash).offset().top
          },
          800,
          function () {
            // Add hash (#) to URL when done scrolling (default click behavior)
            window.location.hash = hash;
            // Close main nav.
            headroom.unpin();
          }
        );
    } // End if
  });
});



// Graphic content
jQuery(document).ready(function () {

  //eraseCookie('allow_graphic_content');

  var allow_graphic_content = readCookie("allow_graphic_content");

  if (allow_graphic_content == "yes") {
    console.log("Graphic content allowed.");
    // Remove censor class from all is-censored elements
    jQuery('.is-censored').removeClass('censor');
  } else {
    console.log("Graphic content IS NOT allowed.");
  }
  
});



/*------------------------------
Remove ads for MedlinePlus
------------------------------*/
jQuery(document).ready(function() {
  var medlineplus = readCookie("medlineplus");
  // If this is set then we need to remove ads quick.
  if (medlineplus == 1) {
    // Loop through all ads
    jQuery('.g_as').each(function (i, obj) {
      // If this does not have the medline class on it we need to replace it.
      if (!jQuery(this).hasClass('medline')) {

        if (jQuery(this).hasClass('size-300x250')) {
          // Add the medline class.
          jQuery(this).addClass('medline');
          jQuery(this).html('<img src="/app/themes/skinsight/dist/images/medline_300x250.png" class="img-fluid"/>');
        }
        else if (jQuery(this).hasClass('size-728x90')) {
          // Add the medline class.
          jQuery(this).css('display', 'none');
          //jQuery(this).addClass('medline');
          //jQuery(this).html('<img src="/app/themes/skinsight/dist/images/medline_728x90.png" class="img-fluid"/>');
        }
        else if (jQuery(this).hasClass('size-300x600')) {
          // Add the medline class.
          jQuery(this).addClass('medline');
          jQuery(this).html('<img src="/app/themes/skinsight/dist/images/medline_300x600.png" class="img-fluid"/>');
        }

      }
    });

    // Hide the Aysa plugs.
    jQuery('.aysa-cta').css('display', 'none');
    jQuery('.aysa-plug').css('display', 'none');
  }

});


//  Professional resource center modal
jQuery(document).ready(function () {
  
  // Check to see if modal window is present
  if (jQuery('.modal-prof-rc').length > 0) {

    // Check if they have the cookie saved already.
    var access_prof_rc = readCookie("vdx_prof_rc_access");

    // No cookie? Check the query string.
    if (access_prof_rc != 'yes') {

      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());

      // Confirm key is correct
      if (params['k'] == 'rTzuwIqxm') {
        access_prof_rc = 'yes';

        // Set cookie up for 4 weeks.
        createCookie("access_prof_rc", "yes", 30);
      }

    }

    if (access_prof_rc != 'yes') {
      //jQuery(".modal-prof-rc").modal("show");
      jQuery('.modal-prof-rc').modal({ backdrop: 'static', keyboard: false });
    }
  }

});

//  Once the main sc swiper is loaded, let's get it's height and set the minimum height so it never jumps.
jQuery(document).ready(function () {
  
  if ( jQuery('.swiper-main .swiper-wrapper').length > 0 ) { 
    var sc_height = jQuery('.swiper-main .swiper-wrapper').height();

    jQuery('.swiper-main .swiper-wrapper').css('min-height', sc_height + 'px');

  }

});


//
// Toggle for age links in the resource center.
//
/*
jQuery(document).ready(function () {
  jQuery('.slider-filters .age-links a').on('click', function () { 
    var age = jQuery(this).attr('data-age');

    jQuery('.swiper-slide').removeClass('age-hidden');

    console.log('Age: ' + age);
    // Hide everything in the slider except this ages images
    jQuery('.swiper-main .swiper-slide:not(.age-' + age + '), .swiper-thumbs .swiper-slide:not(.age-' + age + ')').addClass('age-hidden');
    jQuery('.swiper-main .swiper-slide:not(.age-' + age + ')').removeClass('swiper-slide');

    swiper_sc.update();
    swiper_sc_thumbs.update();


    return false;
  });
});
*/